<template>
    <div class="link-question-modal">
        <!--TitleBaseBox :title="title" @close="close" @confirm="confirmClick"-->
        <el-dialog :title="title" :visible="true" width="400px" :append-to-body="true" :lock-scroll="false" @close="close">
            <div class="link-question-content">
                <div class="question-word">
                    <div class="link-word-text">{{ wordLabel }}</div>
                    <div class="link-word-show">{{ word }}</div>
                </div>
                <div class="question-word hide-word-color">
                    <div class="link-word-text">{{ wordColorLabel }}</div>
                    <div class="link-word-color" :style="{ background: wordColor }"></div>
                </div>
                <div class="question-word">
                    <div class="link-word-text">{{ standQuestion }}</div>
                    <div class="linked-question-search">
                        <QuestionSearch class="question-search" :question="initQustion" @questionSelected="questionSelected" />
                    </div>
                </div>
                <div class="link-word-delete" v-show="data.id" @click="deleteLink">
                    <Icon :width="16" :height="18" bgPosition="-96px 0" hoverBgPosition="-96px -22px" class="link-delete-icon" />
                    {{ deleteLabel }}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">{{ $t("zhiji.common.cancel") }}</el-button>
                <el-button type="primary" @click="confirmClick">{{ $t("zhiji.common.confirm") }}</el-button>
            </span>
        </el-dialog>
        <!--/TitleBaseBox-->
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import QuestionSearch from "@/views/zhiji/components/questionSearch/QuestionSearch";
import i18n from "@/i18n";

export default {
    name: "LinkQuestionModal",
    props: ["data"],
    components: {
        Icon,
        QuestionSearch
    },
    data() {
        return {
            word: this.data.word,
            wordColor: this.data.wordColor,
            selectedQues: {},
            initQustion: this.data.question,
            pageIdx: 1, // 从1开始
            pageSize: 20
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.answer.textWidget.linkQuestion");
        },
        wordLabel() {
            return this.$t("zhiji.answer.textWidget.selectedText");
        },
        wordColorLabel() {
            return this.$t("zhiji.answer.textWidget.textColor");
        },
        standQuestion() {
            return this.$t("zhiji.answer.textWidget.standQuestion");
        },
        deleteLabel() {
            return this.$t("zhiji.answer.textWidget.deletLink");
        }
    },
    mounted() {
        this.selectedQues = this.data;
        // 新增时推荐匹配度最高的问法
        !this.data.id ? this.getRecommendQuestion() : "";
    },
    methods: {
        close() {
            this.data.cancel && this.data.cancel({});
            this.$emit("closeModal");
        },
        getRecommendQuestion() {
            this.data.word &&
                this.zhiji
                    .requestByServiceName("queryQuestionByName", {
                        pageIdx: this.pageIdx,
                        pageSize: this.pageSize,
                        searchText: this.data.word
                    })
                    .then(resp => {
                        if (resp && resp.quesList && resp.quesList.length > 0) {
                            let firstRecomQues = resp.quesList[0];
                            this.initQustion = firstRecomQues.question;
                            this.selectedQues = firstRecomQues;
                        }
                    })
                    .catch(() => (this.isLoading = false));
        },
        questionSelected(data) {
            this.selectedQues = data;
        },
        deleteLink() {
            this.data.confirm &&
                this.data.confirm({
                    id: this.data.id || "",
                    type: "delete",
                    wordColor: this.data.wordColor,
                    questionData: this.selectedQues,
                    word: this.word
                });

            this.$emit("closeModal");
        },
        confirmClick() {
            if (this.selectedQues.question == undefined || !this.selectedQues.question) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("zhiji.answer.textWidget.linkQuestion")
                    }
                });
            } else {
                this.data.confirm &&
                    this.data.confirm({
                        id: this.data.id || "",
                        type: this.data.id ? "update" : "add",
                        word: this.word,
                        wordColor: this.data.wordColor,
                        questionData: this.selectedQues
                    });

                this.$emit("closeModal");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
/*.link-question-modal {
    width: 100%;
    height: 100%;
    background-color: rgba(18, 22, 37, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;*/

.link-question-content {
    width: 352px;
}

.question-word {
    margin-bottom: 20px;

    .link-word-text {
        font-size: 14px;
        margin-bottom: 4px;
    }

    .link-word-show {
        min-height: 32px;
        max-height: 108px;
        background: #f2f7fb;
        border: 1px solid #d8e4f0;
        border-radius: 4px;
        padding: 6px 8px 5px;
        box-sizing: border-box;
    }

    .link-word-color {
        width: 64px;
        height: 32px;
    }

    .question-search {
        width: 100%;
        z-index: 1;
    }
}

.hide-word-color {
    // 暂时去掉字体颜色显示
    display: none;
}

.link-word-delete {
    position: absolute;
    bottom: 30px;
    cursor: pointer;
    text-decoration: underline;

    .link-delete-icon {
        vertical-align: -3px;
    }

    &:hover {
        color: #2ec2ff;
        .link-delete-icon {
            background-position: -96px -22px !important;
        }
    }
}
/*}*/
</style>
